import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Research } from './pages/Research';
import { People } from './pages/People';
import { Contact } from './pages/Contact';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2riklx1c3g39f">
      <ScrollToTop data-id="element-1" data-mp="2mm2j470bqezq" />
      <div className="flex min-h-screen w-full flex-col bg-paper font-sans text-ink-900" data-id="element-2" data-mp="2mmvl6uoc8gbj">
        <SiteHeader data-id="element-3" data-mp="31ayrk56alu0v" />
        <main className="flex-1" data-id="element-4" data-mp="31bia9o3romfy">
          <Routes data-id="element-5" data-mp="31cjnnz899l0u">
            <Route path="/" element={<Home data-id="element-7" data-mp="2wjql9i09eorx" />} data-id="element-6" data-mp="2wka1mua9h53u" />
            <Route path="/services" element={<Services data-id="element-9" data-mp="2wi5mfg6wwjo9" />} data-id="element-8" data-mp="2wiffxdr618yp" />
            <Route path="/research" element={<Research data-id="element-11" data-mp="28t4j27cxrypu" />} data-id="element-10" data-mp="28tw4ipctkg2e" />
            <Route path="/people" element={<People data-id="element-13" data-mp="23vkzqt1dsvr1" />} data-id="element-12" data-mp="28sbad0uf2z52" />
            <Route path="/contact" element={<Contact data-id="element-15" data-mp="23v2td3l0915e" />} data-id="element-14" data-mp="23u9v6r043jyv" />
            <Route path="*" element={<Home data-id="element-17" data-mp="3ikr002qv3a7b" />} data-id="element-16" data-mp="3ijxo6nd1puib" />
          </Routes>
        </main>
        <SiteFooter data-id="element-18" data-mp="3ihv1ac76whht" />
      </div>
    </BrowserRouter>;
}